import PropTypes from "prop-types";
import React from "react";
import moment from "moment";

// Single date rendering for table cells, so every column reads the same way.
export const dateCell = (value) =>
  value ? moment(value).format("YYYY-MM-DD HH:mm") : "-";

// The refresh affordance carries its own look (.cf-refresh, styles/_buttons.scss)
// so every toolbar gets the same target without restyling it page by page.
export const RefreshButton = ({
  refreshing,
  onRefresh,
  className,
  ...forA
}) => {
  return (
    <a
      href="#!"
      className={className ? `cf-refresh ${className}` : "cf-refresh"}
      onClick={(event) => {
        event.preventDefault();
        onRefresh();
      }}
      {...forA}
    >
      <span
        aria-hidden="true"
        className={`fa-solid fa-arrows-rotate${refreshing ? " fa-spin" : ""}`}
      />
    </a>
  );
};

RefreshButton.propTypes = {
  refreshing: PropTypes.bool.isRequired,
  onRefresh: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export const SortableHeader = ({ label, onUpdateSort, className }) => {
  if (!onUpdateSort)
    return (
      <th className={className}>
        <span>{label}</span>
      </th>
    );

  return (
    <th className={className}>
      <span>{label}</span>
      <a
        href="#!"
        className="ms-1"
        onClick={(event) => {
          event.preventDefault();
          onUpdateSort();
        }}
      >
        <span
          aria-hidden="true"
          className="fa-solid fa-sort collapseToggleTitle"
        />
      </a>
    </th>
  );
};

SortableHeader.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  onUpdateSort: PropTypes.func,
};

SortableHeader.defaultProps = {
  className: "",
  onUpdateSort: null,
};

export const fixHeaders = (...label) => {
  return (
    <thead>
      <tr>
        {label.map((l, index) => (
          <th key={l + "-" + index}>
            <span>{l}</span>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export const clickableRows = (handleClick, el, key, ...val) => {
  return (
    <tr
      onClick={(event) => handleClick(event, el)}
      className="clickable-row"
      key={key}
    >
      {val.map((v, i) => (
        <td key={i + key}>{v}</td>
      ))}
    </tr>
  );
};

export const rows = (...val) => {
  return (
    <tr>
      {val.map((v) => (
        <td key={v}>{v}</td>
      ))}
    </tr>
  );
};
